module.exports = __webpack_public_path__ + "static/media/mathieub.4484d43b.jpg";